import { mapMutations,} from "vuex";
// import Swal from "sweetalert2";


export default {
  methods: {
    ...mapMutations("popup", ["SET_ACTIVE_POPUP"]),

    async showPopup(id) {
      // console.log(id);
      this.SET_ACTIVE_POPUP(id)

      return id;
    },
    // swal
    showSwalSuccess(title = "") {
      this.$notify({
        offset: 60,
        title: 'Thành công',
        message: `${title} thành công!`,
        type: 'success',
        customClass: 'notify_custom',
        // duration: 1000000,
      });
    },

    showSwalError(title = "", message = "") {
      this.$notify.error({
        offset: 60,
        title: title + " thất bại!",
        message: "Error: " + message,
        customClass: 'notify_custom',
        // duration: 1000000,
      });
    },
    showNotify(title = "", message = "", type = "success") {
      this.$notify({
        offset: 60,
        title,
        message,
        customClass: 'notify_custom',
        type,
        // duration: 1000000,
      });
    }
  },
};
